import { useContext, useEffect, useState } from "react";
import { AreasPill } from "../components/customPill";
import { getCountry } from "../../../API/Lists/country";
import { getCandidateInfo, putCandidateInfo } from "../../../API/Candidates/Cadidate";
import { getListArea } from "../../../API/Lists/area";
import { firstLoginTranslate } from "../../../i18n/translatedMessages";
import { EmployerContext } from "../../../Store/EmployerContext";

import CustomInput from "../components/customInput";
import CustomSelect from "../components/customSelect";
import Loading from "../../../Components/Loading/Loading";
import Swal from "sweetalert2";

import { translate as translateAreas } from "../../../i18n/messages/Lists/areasCorrelation";
import { useIntl } from "react-intl";

const InfoFirstLogin = ({ onNextStep }) => {
  const locale = useIntl().locale;
  const language = locale === "PT-BR" ? "pt" : "es";
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState({
    name: "",
    mail: "",
    phone: "",
    country_id: "",
    areas: [],
  });
  const [countryList, setCountryList] = useState();
  const [areaList, setAreaList] = useState([]);

  const isFormValid = () => {
    return data.name === "" || data.entry_date === "" || data.hierarchical_level_id === "0" || data.country_id === "0" || data.areas.length === 0;
  };

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setData({
      ...data,
      [name]: value,
    });
  };

  useEffect(() => {
    const fetchList = async () => {
      const [countryList, personalInfo, areaList] = await Promise.all([getCountry(), getCandidateInfo(localStorage.getItem("candidateId")), getListArea()]);
      setCountryList(countryList);
      setAreaList(areaList);
      setData(personalInfo.item);
      setIsLoading(false);
    };

    fetchList();
  }, []);

  const handleStartClick = async () => {
    setIsLoading(true);
    const sendData = {
      name: data.name,
      phone: data.phone,
      country: Number(data.country_id),
      areas: data.areas,
    };
    const resp = await putCandidateInfo(sendData, localStorage.getItem("candidateId"));

    if (resp.items === "Updated candidate") {
      onNextStep();
      setIsLoading(false);
    } else {
      setIsLoading(false);
      Swal.fire({
        title: "Hola 👋",
        text: "Algo ha ido mal, inténtalo más tarde!",
        icon: "info",
        confirmButtonText: "Ok",
      });
    }
  };

  const areaTranslated = areaList.map((item) => ({
    ...item,
    value: translateAreas[language][item?.area],
  }));

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <div className="me-5 text-white w-100">
          <h3>
            <strong>{firstLoginTranslate.infoFirstLoginTitle}</strong>
          </h3>
          <div className="mb-3 text-gray">{firstLoginTranslate.infoFirstLoginText}</div>

          <div className="step2-form p-0 mt-5">
            <div className="mb-5">
              <CustomInput label={firstLoginTranslate.infoFirstLoginName} name={"name"} value={data.name} onChange={handleChange} />
            </div>
            <div className="mb-5">
              <CustomInput label={firstLoginTranslate.infoFirstLoginEmail} name={"mail"} disabled={true} value={data.mail} onChange={handleChange} />
            </div>
            <div className="mb-5">
              <CustomInput label={firstLoginTranslate.infoFirstLoginPhone} name={"phone"} value={data.phone} onChange={handleChange} />
            </div>
            <div className="mb-5">
              <CustomSelect
                label={firstLoginTranslate.infoFirstLoginCountry}
                name={"country_id"}
                value={data.country_id}
                list={countryList}
                propriety={"name"}
                onChange={handleChange}
              />
            </div>
            <div className="mb-5">
              <div className="custom-label fw-bold mb-2" style={{ color: "#CACCFC" }}>
                {firstLoginTranslate.infoFirstLoginAreas}
              </div>
              <AreasPill title={"Áreas de Interes"} data={data.areas} areaType={"value"} handleChange={handleChange} areaList={areaTranslated} />
            </div>
          </div>

          <button className="custom-btn mt-2" disabled={isFormValid()} style={{ backgroundColor: isFormValid() ? "gray" : "" }} onClick={handleStartClick}>
            {firstLoginTranslate.firstLoginBtn}
          </button>
        </div>
      )}
    </>
  );
};

export default InfoFirstLogin;
